export const urlParams = {
  key: 'AIzaSyDF9ij-0hu-gin98lu1VNk6zfCXR8wXv-E'
}
export const center = {
  lat: 25.0337753,
  lng: 121.4949492
}
export const zoom = 13

export const options = {
  gestureHandling: 'greedy',
  minZoom: process.env.NODE_ENV === 'production' ? 10 : null,
  restriction: {
    latLngBounds: {
      north: 25.358889,
      south: 21.861058,
      west: 119.374656,
      east: 122.376178,
    },
    strictBounds: false,
  },
}

export const gmapSeachUrl = (address) => {
  return `https://google.com/maps/search/?api=1&query=${address}`
}